import { XCircle } from 'lucide-react';
import { ASSETS } from '../constants/site';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050B14] flex items-center justify-center px-6">
      <div data-testid="payment-cancel-page" className="gold-ring rounded-3xl bg-[#0F1C33]/70 p-10 max-w-md w-full text-center">
        <img src={ASSETS.icon} alt="GSLAB" className="h-16 w-16 rounded-xl mx-auto mb-6" />
        <XCircle size={40} className="text-slate-500 mx-auto mb-5" />
        <h1 className="font-display font-bold text-2xl mb-2">Checkout cancelled.</h1>
        <p className="text-sm text-slate-400 mb-8">No charge was made. Whenever you're ready, your build slot is waiting.</p>
        <a href="/#pricing" data-testid="payment-cancel-retry-link" className="inline-block bg-gradient-to-r from-[#D4AF37] to-[#F3C64F] text-[#050B14] font-bold rounded-full px-7 py-3 text-sm">
          Back to Pricing
        </a>
      </div>
    </div>
  );
}
